import styled from "styled-components";

const Wrapper = styled.div`
  color: rgba(0, 0, 0, 0.6);
`;

const Title = styled.div`
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  margin-top: 32px;
`;
const SubNote = styled.div`
  margin-top: 12px;
`;

const SubNoteBig = styled.div`
  margin-top: 32px;
`;

const ExternalLink = styled.a`
  text-decoration: underline;
  color: inherit;
`;

const EmphSlight = styled.span`
  color: rgba(0, 0, 0, 0.85);
`;

const HowPetitionsMatterContent = () => (
  <Wrapper>
    Petitions on Verified Voice have no legal authority on their own.
    <SubNote>
      <EmphSlight>
        For a policy to become state law in Florida, it must either be enacted
        by the Florida state legislature or voted in directly by Florida voters
        through a ballot proposition.
      </EmphSlight>
    </SubNote>
    <SubNote>
      <EmphSlight>
        Verified Voice petitions support policy ideas to become law through
        either of these legal pathways by showing where real, verified
        registered voters stand on issues.
      </EmphSlight>
    </SubNote>
    <Title>Pressuring the state legislature</Title>
    <SubNote>
      Verified Voice petition results reflect genuine voter opinion, consisting
      only of verified voter stances. A {"petition's"} results tally can also be
      broken down by state House or Senate district.
    </SubNote>
    <SubNote>
      This clear signal of voter opinion in any constituency can motivate
      lawmakers to act. After all, it is the voters in any district who have the
      power to elect officials that properly represent them.
    </SubNote>
    <Title>Supporting ballot initiatives</Title>
    <SubNote>
      In Florida, proposed policy can appear on the ballot for voters to vote
      into law following{" "}
      <ExternalLink
        href="https://dos.fl.gov/elections/laws-rules/constitutional-amendmentsinitiatives/"
        target="_blank"
      >
        this procedure
      </ExternalLink>
      . Pursuing a ballot initiative is difficult and costly, requiring the
      sponsor of the initiative to gather hundreds of thousands of physical
      signatures to even place the initiative on the ballot, a huge financial
      cost on its own. It then takes a 60% supermajority of the statewide vote
      to become law.
    </SubNote>
    <SubNote>
      Given this involved process, advocates only pursue a ballot initiative if
      an idea has the potential to win a statewide election. Verified Voice
      petitions, with their verified voter participation, can signal this
      potential. Furthermore, if advocates do decide to gather physical
      signatures for a ballot iniative with a corresponding Verified Voice
      petition, we can guide users on how to physically sign the initiative.
      This reduces the cost of a {"campaign's"} paid signature-gathering
      efforts, and turns virtual support on the platform into real, legal
      support to place an idea on the ballot.
    </SubNote>
    <SubNoteBig>
      Right now, {"we're"} early, and any new petition on the platform will
      necessarily start with only a handful of verified stances. But the size of
      a {"petition's"} verified tally can make a real difference in its path to
      becoming law. Every stance you add moves that tally, and moves Verified
      Voice closer to being a signal lawmakers and campaigns actually have to
      reckon with.
    </SubNoteBig>
    <SubNote>
      Please reach out with questions, comments, concerns, to add your own
      petition, or to discuss your advocacy goals. We strive to make citizen
      voices count.
    </SubNote>
  </Wrapper>
);

export default HowPetitionsMatterContent;
